export default defineNuxtRouteMiddleware((to) => {
  if (to.meta?.deprecated) {
    return navigateTo("/");
  }
});
